/**
 * Normalize forum `tags` from list/detail API rows for Community feed rows and v2 create navigation.
 */

export function normalizeForumTagsForThread(raw) {
  if (Array.isArray(raw)) return raw.map((t) => String(t)).filter(Boolean);
  if (raw == null) return [];
  if (typeof raw === "string") {
    const s = raw.trim();
    if (!s) return [];
    if (s.startsWith("{") && s.endsWith("}")) {
      return s
        .slice(1, -1)
        .split(",")
        .map((p) => p.replace(/^"+|"+$/g, "").trim())
        .filter(Boolean);
    }
    try {
      const j = JSON.parse(s);
      return Array.isArray(j) ? j.map(String).filter(Boolean) : [];
    } catch {
      return [];
    }
  }
  return [];
}
